import { useContext, useEffect, useRef, useState } from "react";
import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { OverlayPanel } from "primereact/overlaypanel";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

const ActivosOverlayPanel = ({ close, rowData, onChange }) => {
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const op = useRef(null);

  const [loading, setLoading] = useState(false);
  const [activos, setActivos] = useState([]);

  const fetchData = async () => {
    try {
      const response = await getActivosFijos();
      setActivos(response.filter(i => i?.ActivoPadre === 0 || !i?.ActivoPadre));
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const columns = [
    {
      header: "Tipo",
      headerEn: "Type",
      field: "Type",
      className: 'small',
    },
    {
      header: "Código Activo",
      headerEn: "Active Code",
      field: "CodigoActivo",
      className: 'Xsmall',
    },
    {
      header: "Activo",
      headerEn: "Active",
      field: "NombreActivo",
      className: "Xsmall",
      flex: 1,
      minWidth:200,
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
      className: "medium",
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
      className: "medium",
    },
    {
      header: "Serie",
      headerEn: "Serie",
      field: "Serie",
      className: "medium",
    },
  ];

  const table = {
    Data: activos,
    loading: loading,
    Columns: columns,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>

<div className="p-inputgroup">
        <InputText
          value={rowData.Requisa}
          disabled
          placeholder="Activo"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>
      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelActivos"
        onHide={close}
      >
        <div style={{ width: 1000, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default ActivosOverlayPanel;
